<template>
	<div>
		<div class="list">
			<div class="list-item iconfont icon-back" v-if="dir.length > 0" @click="dir_clear"></div>
			<template v-for="(val,key) in list">
				<template v-if="val.is_dir">
					<el-tooltip placement="top" :key="key">
						<div slot="content">文件夹名称：{{val.name}}<br/>创建时间：{{val.time}}</div>
						<div class="list-item iconfont icon-folder" :key="key" @click="dir_change(val.name)">
							<div class="list-title">{{val.name}}</div>
						</div>
					</el-tooltip>
				</template>
				<template v-if="val.is_file">
					<el-tooltip placement="top" :key="key">
						<div slot="content">文件名称：{{val.name}}<br/>创建时间：{{val.time}}<br/>大小：{{val.size}}KB</div>
						<div class="list-item iconfont icon-file-fill" :key="key" @click="image_choose(val.url)">
							<div class="list-title">{{val.name}}</div>
						</div>
					</el-tooltip>
				</template>
				<template v-if="val.is_video">
					<el-tooltip placement="top" :key="key">
						<div slot="content">视频名称：{{val.name}}<br/>创建时间：{{val.time}}<br/>大小：{{val.size}}KB</div>
						<div class="list-item iconfont icon-video" :key="key" @click="image_choose(val.url)">
							<div class="list-title">{{val.name}}</div>
						</div>
					</el-tooltip>
				</template>
				<template v-if="val.is_image">
					<el-tooltip placement="top" :key="key">
						<div slot="content">图片名称：{{val.name}}<br/>创建时间：{{val.time}}<br/>宽 * 高：{{val.width}}px * {{val.height}}px<br/>大小：{{val.size}}KB</div>
						<div class="list-item" :key="key" @click="image_choose(val.url)">
							<img :src="val.url" alt="">
							<div class="list-title">{{val.name}}</div>
						</div>
					</el-tooltip>
				</template>
			</template>
		</div>
		<div class="button">
			<div class="choose">
				<el-tooltip content="点击取消选择" v-for="(val,key) in choose_list" :key="key" >
					<div class="choose-item" :style="{ backgroundImage:'url('+val+')' }" @click="image_del(key)"></div>
				</el-tooltip>
			</div>
			<div class="confirm">
				<el-button type="info" @click="create_dir">创建文件夹</el-button>
			</div>
			<div class="confirm">
				<el-button type="warning" @click="use_url">使用在线图片</el-button>
			</div>
			<div class="upload">
				<el-upload :http-request="server_upload" :accept="accept" :multiple="isMore"  :show-file-list="false" :before-upload="server_check">
					<el-button type="success">上传图片</el-button>
				</el-upload>
			</div>
			<div class="confirm">
				<el-button type="primary" @click="confirm">确定</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name : "vue-upload-server",
		props : {
			isMore : {type : Boolean, default : false},
			mixWidth : {type : [String,Number], default:0},
			maxWidth : {type : [String,Number], default:0},
			mixHeight : {type : [String,Number], default:0},
			maxHeight : {type : [String,Number], default:0},
			width :  {type : [String,Number], default:0},
			height : {type : [String, Number], default : 0},
			scale : {type : String, default : ''},
			maxSize : {type : [String,Number], default : 0},
			serverType : {type : String, default : 'all'},
			accept : {type : String, default : ''},
		},
		data (){
			return {
				list : [],
				choose_list : [],
				dir : [],
			}
		},
		mounted : async function(){
			try{
				await this.get_list();
			}catch (e){
				console.log(e);
				return false;
			}
		},
		methods : {
			get_list : async function (){
				try{
					this.$_showLoading();
					this.list = [];
					let res;
					if (this.serverType == 'all'){
						res = await this.$_api.upload_get('get_list', {dir : this.dir.join('/')})
					}else if (this.serverType =='image'){
						res = await this.$_api.upload_get('image_list', {dir : this.dir.join('/')})
					}else{
						res = await this.$_api.upload_get('video_list', {dir : this.dir.join('/')})
					}
					this.$_hideLoading();
					if (res.errcode == 0){
						this.list = res.list;
					}
				}catch (e){
					console.log(e);
					return false;
				}
			},
			dir_change : async function  (dir){
				try{
					let dirs = this.dir;
					dirs.push(dir);
					this.dir = dirs;
					this.list = [];
					await this.get_list();
				}catch (e){
					console.log(e);
					return false;
				}
			},
			dir_clear : async function  (){
				try{
					let key = this.dir.length - 1
					let dirs = this.dir;
					dirs = this.$_tools.unset(dirs,key);
					this.dir = dirs;
					this.list = [];
					await this.get_list();
				}catch (e){
					console.log(e);
					return false;
				}
			},
			image_choose : function  (url){
				console.log(url);
				let choose_list = this.choose_list;
				let is_more = this.isMore;
				if (is_more){
					let in_array = this.$_tools.in_array(choose_list,url);
					if (in_array >-1){
						this.$_showToastInfo('已选择');
						return;
					}
					choose_list.push(url);
					this.choose_list = choose_list;
				}else{
					choose_list = [];
					choose_list.push(url);
					this.choose_list = choose_list;
				}
			},
			image_del : function  (key){
				let choose_list = this.choose_list;
				choose_list = this.$_tools.unset(choose_list,key);
				this.choose_list = choose_list;
			},
			confirm : function  (){
				let choose_list = this.choose_list;
				if (choose_list.length > 0){
					if (this.isMore){
						this.$emit('submit',choose_list);
					}else{
						this.$emit('submit',choose_list[0]);
					}
				}
			},
			
			create_dir : async function  (){
				try{
					let dir = await this.$_prompt('请填写文件夹名称(英文/数字/下划线组合)');
					if (dir){
						this.$_showLoading();
						let res = await this.$_api.upload_get('create_dir', {path : this.dir.join('/'),dir : dir});
						this.$_hideLoading();
						this.$_showToast(res.errmsg,res.style);
						if (res.errcode == 0){
							this.list = [];
							await this.get_list();
						}
					}
				}catch (e){
					console.log(e);
					return false;
				}
			},
			use_url : async function  (){
				try{
					let url = await this.$_prompt('请粘贴图片链接地址');
					if (url){
						if (this.isMore){
							let list = this.choose_list;
							let in_array = this.$_tools.in_array(list,url);
							if (in_array>-1){
								this.$_showToastNone('已存在');
								return ;
							}
							list.push(url);
							this.choose_list = list;
						}else{
							this.choose_list=[];
							this.choose_list.push(url);
						}
						this.$emit('submit', this.choose_list);
					}
				}catch (e){
					console.log(e);
					return false;
				}
			},
			server_check : function  (e){
				let that = this;
				let check_size = true;
				if (that.maxSize>0){
					let size = e.size / 1024;
					if (size > that.maxSize){
						that.$_showToastNone('最大只能上传' + that.maxSize + 'KB');
						check_size = false;
					}
				}

				let check_image = new Promise(function (resolve, reject){
					if (that.maxWidth || that.maxHeight || that.width || that.height || that.scale || that.minWidth || that.minHeight){
						let _url = window.URL || window.webkitURL;
						let image = new Image();
						image.onload = function (){
							//检查宽
							if (that.width){
								if (image.width != that.width){
									that.$_showToastNone('图片宽必须是' + that.width + 'px');
									reject();
								}
							}
							//检查高
							if (that.height){
								if (image.height != that.height){
									that.$_showToastNone('图片高必须是' + that.height + 'px');
									reject();
								}
							}
							//检查比例
							if (that.scale){
								let scale = that.scale.split('|');
								if ((image.width / image.height) != (scale[0] / scale[1])){
									that.$_showToastNone('图片宽高比例必须是' + scale[0] + ':' + scale[1]);
									reject();
								}
							}
							//最小宽
							if (that.minWidth){
								if (image.width < that.minWidth){
									that.$_showToastNone('图片最小宽必须是' + that.minWidth + 'px');
									reject();
								}
							}
							//最小高
							if (that.minHeight){
								if (image.height < that.minHeight){
									that.$_showToastNone('图片最小高必须是' + that.minHeight + 'px');
									reject();
								}
							}
							//最小宽
							if (that.maxWidth){
								if (image.width > that.maxWidth){
									that.$_showToastNone('图片最大宽必须是' + that.maxWidth + 'px');
									reject();
								}
							}
							//最小高
							if (that.maxHeight){
								if (image.height > that.maxHeight){
									that.$_showToastNone('图片最大高必须是' + that.maxHeight + 'px');
									reject();
								}
							}
							resolve();
						}
						image.src = _url.createObjectURL(e);
					}else{
						resolve();
					}
				})
				return check_size && check_image;
			},
			server_upload : async function  (e){
				try{
					if (e.file){
						this.$_showLoading();
						let res = await this.$_api.upload(e.file, this.dir.join('/'));
						this.$_hideLoading();
						if (res.errcode == 0){
							await this.get_list();
						}else{
							this.$_showToastNone(res.errmsg);
						}
					}
				}catch (e){
					console.log(e);
					return false;
				}
			},
		},
	}
</script>

<style scoped>
	.list { width: 860px; height: 550px; overflow-x: hidden; overflow-y: auto; }
	.list:after { content: ''; display: table; clear: both; }
	.list-item { position: relative; width: 100px; height: 100px; border-radius: 5px; border: 1px solid #dcdfe6; overflow: hidden; float: left; margin-right: 10px; margin-bottom: 10px; cursor: pointer; line-height: 100px; text-align: center; font-size: 35px; color: #c0c4cc; }
	.list-item:hover { border-color: #409eff; color: #409eff; }
	.list-item img { width: 100%; margin-top: 50%; transform: translateY(-50%); }
	.list-title { position: absolute; left: 0; right: 0; bottom: 0; height: 24px; line-height: 24px; font-size: 14px; overflow: hidden; white-space: nowrap; text-overflow:ellipsis; background: rgba(0,0,0,0.4); color: #ffffff; padding: 0 10px; }

	.button { height: 40px; padding-top: 20px; display: flex; }
	.choose { flex: 1; overflow-y: hidden; overflow-x: auto; }
	.choose:after { content: ''; display: table; clear: both; }
	.choose-item { float: left; margin-right: 10px; height: 40px; width: 40px; box-sizing: border-box; border: 1px solid #409eff; background: #ffffff no-repeat center; background-size: cover; border-radius: 2px; cursor: pointer; }
	.upload { padding-left: 10px; }
	.confirm { padding-left: 10px; }
</style>
